import { BasketItemQuote } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedQuoteConfirmation } from './checkout-completed-quote-confirmation.interface';

export interface CheckoutCompletedQuote {
  item: BasketItemQuote;
  confirmation: CheckoutCompletedQuoteConfirmation;
}
